import styled from 'styled-components';
import {CenteredDivWrap} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
// THEME

const S = {
  Container: styled.div(
    props => `
    max-width: 120rem;
    width: 100%;
    margin: 0 auto;
    padding: 3.5rem 0;
  `,
  ),

  ArrowContainer: styled.div(
    props => `
    width: 40px;
    height: 40px;
    cursor: pointer;
  `,
  ),

  LeftArrowWrapper: styled(CenteredDivWrap)(
    props => `
    width: 100%;
    height: 100%;
    background: ${props.theme.colors.goWhite.base};
    border-radius: 50% 0 0 50%;
  `,
  ),

  RightArrowWrapper: styled(CenteredDivWrap)(
    props => `
    width: 100%;
    height: 100%;
    background: ${props.theme.colors.goWhite.base};
    border-radius: 0 50% 50% 0;
  `,
  ),

  SimilarHotelsCardsContainer: styled.section(
    props => `
    margin: ${props.theme.spacing.xxlarge} 0 0;
    background: ${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.xxxlarge};
    border-radius:${props.theme.misc.borderRadius.xxxlarge};
    display: flex;
  `,
  ),
  EmblaCarouselContainer: styled.div`
    overflow: hidden;
  `,

  SimilarHotelsScrollContainer: styled.div(
    props => `
    display: flex;
  `,
  ),
  ErrorMessage: styled.div(
    props => `
    color: ${props.theme.colors.goRed.base};
    margin: ${props.theme.spacing.large} 0;
  `,
  ),
  NoSimilarHotelsText: styled.div(
    props => `
    margin: ${props.theme.spacing.large} 0;
  `,
  ),
};

export default S;
